/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Box } from '@chakra-ui/react';
import { checkLogin } from '../utils';
import Header from './Header';
import Footer from './Footer';

function Layout(props) {
	const isLogin = checkLogin();
	const history = useHistory();

	useEffect(() => {
		if (!isLogin) {
			history.push('/login');
		}
	}, []);

	return (
		<>
			<Header hidden={props?.hiddenHeader} />
			<Box minH="calc(100vh - 80px)">{props?.children ? props?.children : null}</Box>
			<Footer hidden={props?.hiddenFooter} />
		</>
	);
}

export default Layout;
